// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reject-confirm-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(20, 27, 35, 0.48);
  backdrop-filter: blur(2px);
}

.reject-confirm-box {
  box-sizing: border-box;
  width: min(100%, 440px);
  max-height: min(90dvh, 720px);
  overflow-y: auto;
  padding: 26px;
  border: 1px solid #ead9d6;
  border-radius: 16px;
  background: #fffaf7;
  color: #2d2524;
  text-align: left;
  box-shadow: 0 20px 56px rgba(40, 23, 20, 0.24);
  animation: reject-confirm-enter 180ms ease-out;
}

.reject-confirm-mark {
  display: grid;
  width: 38px;
  height: 38px;
  place-items: center;
  margin-bottom: 15px;
  border: 1px solid #efc6bf;
  border-radius: 50%;
  background: #fff0ec;
  color: #a83325;
  font-size: calc(20px + var(--kds-font-delta, 0px));
  font-weight: 700;
}

.reject-confirm-title {
  margin: 0;
  color: #2d2524;
  font-size: calc(20px + var(--kds-font-delta, 0px));
  font-weight: 700;
  letter-spacing: -0.025em;
  line-height: 1.25;
}

.reject-confirm-warning {
  margin: 9px 0 21px;
  color: #756563;
  font-size: calc(14px + var(--kds-font-delta, 0px));
  line-height: 1.5;
}

.reject-confirm-fields {
  display: flex;
  flex-direction: column;
  gap: 17px;
}

.reject-confirm-field {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.reject-confirm-label {
  color: #453937;
  font-size: calc(13px + var(--kds-font-delta, 0px));
  font-weight: 650;
}

.reject-confirm-label span {
  color: #ae3528;
}

.reject-confirm-control {
  box-sizing: border-box;
  width: 100%;
  min-height: 46px;
  padding: 11px 12px;
  border: 1px solid #d9cbc7;
  border-radius: 8px;
  background-color: #fffefd;
  color: #2d2524;
  font: inherit;
  font-size: calc(14px + var(--kds-font-delta, 0px));
  line-height: 1.4;
  transition: border-color 140ms ease, box-shadow 140ms ease;
}

.reject-confirm-control:focus {
  outline: none;
  border-color: #a84639;
  box-shadow: 0 0 0 3px rgba(168, 70, 57, 0.15);
}

.reject-confirm-control[aria-invalid="true"] {
  border-color: #b42318;
}

.reject-confirm-textarea {
  min-height: 104px;
  resize: vertical;
}

.reject-confirm-hint {
  margin: -2px 0 0;
  color: #837572;
  font-size: calc(12px + var(--kds-font-delta, 0px));
  line-height: 1.4;
}

.reject-confirm-error {
  margin: 13px 0 0;
  color: #a1261b;
  font-size: calc(13px + var(--kds-font-delta, 0px));
  font-weight: 600;
  line-height: 1.45;
}

.reject-confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 24px;
}

.reject-confirm-actions button {
  min-height: 42px;
  padding: 9px 16px;
  border-radius: 8px;
  font: inherit;
  font-size: calc(14px + var(--kds-font-delta, 0px));
  font-weight: 650;
  cursor: pointer;
  transition: background-color 140ms ease, border-color 140ms ease, color 140ms ease,
    opacity 140ms ease;
}

.reject-confirm-cancel {
  border: 1px solid #d5c7c3;
  background: #fffaf7;
  color: #514441;
}

.reject-confirm-cancel:hover:not(:disabled) {
  border-color: #b9a8a3;
  background: #f6eeea;
}

.reject-confirm-submit {
  border: 1px solid #a83325;
  background: #a83325;
  color: #fffaf7;
}

.reject-confirm-submit:hover:not(:disabled) {
  border-color: #8d281d;
  background: #8d281d;
}

.reject-confirm-actions button:focus-visible {
  outline: 3px solid rgba(168, 70, 57, 0.28);
  outline-offset: 2px;
}

.reject-confirm-actions button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

@keyframes reject-confirm-enter {
  from {
    opacity: 0;
    transform: translateY(5px) scale(0.985);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

body.dark .reject-confirm-box {
  border-color: #574442;
  background: #292322;
  color: #f2e8e4;
  box-shadow: 0 20px 56px rgba(0, 0, 0, 0.42);
}

body.dark .reject-confirm-mark {
  border-color: #71443e;
  background: #402a27;
  color: #ff9a88;
}

body.dark .reject-confirm-title {
  color: #fff4ef;
}

body.dark .reject-confirm-warning,
body.dark .reject-confirm-hint {
  color: #c1adaa;
}

body.dark .reject-confirm-label {
  color: #eadbd6;
}

body.dark .reject-confirm-label span {
  color: #ff9a88;
}

body.dark .reject-confirm-control {
  border-color: #65534f;
  background-color: #332b29;
  color: #fff4ef;
  color-scheme: dark;
}

body.dark .reject-confirm-control:focus {
  border-color: #e17d6d;
  box-shadow: 0 0 0 3px rgba(225, 125, 109, 0.2);
}

body.dark .reject-confirm-error {
  color: #ff9a88;
}

body.dark .reject-confirm-cancel {
  border-color: #665550;
  background: #332b29;
  color: #f1e5df;
}

body.dark .reject-confirm-cancel:hover:not(:disabled) {
  border-color: #8b716a;
  background: #403532;
}

body.dark .reject-confirm-submit {
  border-color: #bc5547;
  background: #bc5547;
  color: #fff8f5;
}

body.dark .reject-confirm-submit:hover:not(:disabled) {
  border-color: #d16b5c;
  background: #d16b5c;
}

@media (max-width: 480px) {
  .reject-confirm-overlay {
    align-items: flex-end;
    padding: 12px;
  }

  .reject-confirm-box {
    width: 100%;
    max-height: 90dvh;
    padding: 22px 18px;
    border-radius: 16px;
  }

  .reject-confirm-actions {
    flex-direction: column-reverse;
  }

  .reject-confirm-actions button {
    width: 100%;
    min-height: 46px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .reject-confirm-box {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/KDS/components/EditItem/RejectOrderConfirmation.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,8CAA8C;EAC9C,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kDAAkD;EAClD,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kDAAkD;EAClD,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kDAAkD;EAClD,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,kDAAkD;EAClD,gBAAgB;EAChB,eAAe;EACf;sBACoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE;IACE,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".reject-confirm-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  background: rgba(20, 27, 35, 0.48);\n  backdrop-filter: blur(2px);\n}\n\n.reject-confirm-box {\n  box-sizing: border-box;\n  width: min(100%, 440px);\n  max-height: min(90dvh, 720px);\n  overflow-y: auto;\n  padding: 26px;\n  border: 1px solid #ead9d6;\n  border-radius: 16px;\n  background: #fffaf7;\n  color: #2d2524;\n  text-align: left;\n  box-shadow: 0 20px 56px rgba(40, 23, 20, 0.24);\n  animation: reject-confirm-enter 180ms ease-out;\n}\n\n.reject-confirm-mark {\n  display: grid;\n  width: 38px;\n  height: 38px;\n  place-items: center;\n  margin-bottom: 15px;\n  border: 1px solid #efc6bf;\n  border-radius: 50%;\n  background: #fff0ec;\n  color: #a83325;\n  font-size: calc(20px + var(--kds-font-delta, 0px));\n  font-weight: 700;\n}\n\n.reject-confirm-title {\n  margin: 0;\n  color: #2d2524;\n  font-size: calc(20px + var(--kds-font-delta, 0px));\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  line-height: 1.25;\n}\n\n.reject-confirm-warning {\n  margin: 9px 0 21px;\n  color: #756563;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  line-height: 1.5;\n}\n\n.reject-confirm-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 17px;\n}\n\n.reject-confirm-field {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n\n.reject-confirm-label {\n  color: #453937;\n  font-size: calc(13px + var(--kds-font-delta, 0px));\n  font-weight: 650;\n}\n\n.reject-confirm-label span {\n  color: #ae3528;\n}\n\n.reject-confirm-control {\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 46px;\n  padding: 11px 12px;\n  border: 1px solid #d9cbc7;\n  border-radius: 8px;\n  background-color: #fffefd;\n  color: #2d2524;\n  font: inherit;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  line-height: 1.4;\n  transition: border-color 140ms ease, box-shadow 140ms ease;\n}\n\n.reject-confirm-control:focus {\n  outline: none;\n  border-color: #a84639;\n  box-shadow: 0 0 0 3px rgba(168, 70, 57, 0.15);\n}\n\n.reject-confirm-control[aria-invalid=\"true\"] {\n  border-color: #b42318;\n}\n\n.reject-confirm-textarea {\n  min-height: 104px;\n  resize: vertical;\n}\n\n.reject-confirm-hint {\n  margin: -2px 0 0;\n  color: #837572;\n  font-size: calc(12px + var(--kds-font-delta, 0px));\n  line-height: 1.4;\n}\n\n.reject-confirm-error {\n  margin: 13px 0 0;\n  color: #a1261b;\n  font-size: calc(13px + var(--kds-font-delta, 0px));\n  font-weight: 600;\n  line-height: 1.45;\n}\n\n.reject-confirm-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 24px;\n}\n\n.reject-confirm-actions button {\n  min-height: 42px;\n  padding: 9px 16px;\n  border-radius: 8px;\n  font: inherit;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  font-weight: 650;\n  cursor: pointer;\n  transition: background-color 140ms ease, border-color 140ms ease, color 140ms ease,\n    opacity 140ms ease;\n}\n\n.reject-confirm-cancel {\n  border: 1px solid #d5c7c3;\n  background: #fffaf7;\n  color: #514441;\n}\n\n.reject-confirm-cancel:hover:not(:disabled) {\n  border-color: #b9a8a3;\n  background: #f6eeea;\n}\n\n.reject-confirm-submit {\n  border: 1px solid #a83325;\n  background: #a83325;\n  color: #fffaf7;\n}\n\n.reject-confirm-submit:hover:not(:disabled) {\n  border-color: #8d281d;\n  background: #8d281d;\n}\n\n.reject-confirm-actions button:focus-visible {\n  outline: 3px solid rgba(168, 70, 57, 0.28);\n  outline-offset: 2px;\n}\n\n.reject-confirm-actions button:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n@keyframes reject-confirm-enter {\n  from {\n    opacity: 0;\n    transform: translateY(5px) scale(0.985);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\nbody.dark .reject-confirm-box {\n  border-color: #574442;\n  background: #292322;\n  color: #f2e8e4;\n  box-shadow: 0 20px 56px rgba(0, 0, 0, 0.42);\n}\n\nbody.dark .reject-confirm-mark {\n  border-color: #71443e;\n  background: #402a27;\n  color: #ff9a88;\n}\n\nbody.dark .reject-confirm-title {\n  color: #fff4ef;\n}\n\nbody.dark .reject-confirm-warning,\nbody.dark .reject-confirm-hint {\n  color: #c1adaa;\n}\n\nbody.dark .reject-confirm-label {\n  color: #eadbd6;\n}\n\nbody.dark .reject-confirm-label span {\n  color: #ff9a88;\n}\n\nbody.dark .reject-confirm-control {\n  border-color: #65534f;\n  background-color: #332b29;\n  color: #fff4ef;\n  color-scheme: dark;\n}\n\nbody.dark .reject-confirm-control:focus {\n  border-color: #e17d6d;\n  box-shadow: 0 0 0 3px rgba(225, 125, 109, 0.2);\n}\n\nbody.dark .reject-confirm-error {\n  color: #ff9a88;\n}\n\nbody.dark .reject-confirm-cancel {\n  border-color: #665550;\n  background: #332b29;\n  color: #f1e5df;\n}\n\nbody.dark .reject-confirm-cancel:hover:not(:disabled) {\n  border-color: #8b716a;\n  background: #403532;\n}\n\nbody.dark .reject-confirm-submit {\n  border-color: #bc5547;\n  background: #bc5547;\n  color: #fff8f5;\n}\n\nbody.dark .reject-confirm-submit:hover:not(:disabled) {\n  border-color: #d16b5c;\n  background: #d16b5c;\n}\n\n@media (max-width: 480px) {\n  .reject-confirm-overlay {\n    align-items: flex-end;\n    padding: 12px;\n  }\n\n  .reject-confirm-box {\n    width: 100%;\n    max-height: 90dvh;\n    padding: 22px 18px;\n    border-radius: 16px;\n  }\n\n  .reject-confirm-actions {\n    flex-direction: column-reverse;\n  }\n\n  .reject-confirm-actions button {\n    width: 100%;\n    min-height: 46px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .reject-confirm-box {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
